import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import apiServices from "../../../../services/apiService";
import ComonTable from "../../../common/table/ComonTable";

const VehicleType = () => {
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = [
        { key: "Id", label: "ID" },
        { key: "VehicleType", label: "Vehicle Type" }
    ];

    const fetchVehicleTypes = async () => {
        setLoading(true);
        try {
            const res = await apiServices({
                url: `/VehicleTypeMaster/getAllVehicleType`,
                method: 'GET'
            });

            if (res.success && res.data?.isSuccess) {
                setVehicleTypes(res.data.data || []);
            } else {
                setVehicleTypes([]);
                toast.error("Failed to load vehicle types.");
            }
        } catch (error) {
            console.error("Error fetching vehicle types:", error);
            toast.error("An error occurred while fetching vehicle types.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicleTypes();
    }, []);

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Vehicle Types</h1>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-4 border border-gray-100">
                <ComonTable
                    columns={columns}
                    data={vehicleTypes}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default VehicleType;
